module.exports = __webpack_public_path__ + "img/swbg-active.8ba6b2ea.svg";